<template>
    <aside class="wos__sidebar d-none d-lg-flex flex-column justify-content-start h-100 fixed-top">
        <header class="">
            <router-link :to="{name: 'app.start'}">
                <img src="/assets/images/wos__logo4_white.png" alt="WOS logo" width="170">
            </router-link>
            <p class="text-wellis-gold text-center mt-3 mb-0 noselect">
                <b class="font-weight-bold">UI</b><small>&nbsp;v{{frontendVersion}}</small>
                &nbsp;|&nbsp;<b class="font-weight-bold">Server</b>&nbsp;<small>v{{serverVersion}}</small>
            </p>
            <p class="text-wellis-gold text-center mt-1 mb-0 noselect">
                <small>{{describeUser | cut(30)}}</small>
            </p>
        </header>
        <SidebarNavigation/>
        <footer>&nbsp;</footer>
    </aside>
</template>

<script>
    import SidebarNavigation from "./SidebarNavigation";

    export default {
        name: "Aside",
        components: {SidebarNavigation},
        computed: {
            frontendVersion() {
                return this.$app.version.frontend;
            },

            serverVersion() {
                return this.$root.$children[0].version;
            },

            describeUser() {
                return `${this.$store.getters['authStore/getFullname']} - ${this.$store.getters['authStore/getCompanyName']}`;
            }
        },
    }
</script>

<style scoped>

</style>
